import {ChangeDetectorRef, Component, OnDestroy, OnInit} from "@angular/core";
import {UtilsService} from "../../../../core/utils/utils.service";
import {catchError, finalize, switchMap, tap} from "rxjs/operators";
import {EMPTY, forkJoin, Observable, of, Subscription} from "rxjs";
import {DialogStockAjoutLotSupplier, ProduitDeclinaisonService} from "../../../../core/services/entities/produit-declinaison.service";
import {DATEPICKER_FR, MSG_KEY, MSG_SEVERITY, TYPE_LIST_UDP} from "../../../../core/constants";
import {ResponseWrapper} from "../../../../core/suppliers/wrappers/response-wrapper";
import {UniteDeProductionDTO} from "../../../../core/dtos/unite-de-production-dto";
import {ModelViewInventaire} from "../../inventaire/model-view-inventaire";
import {UnitesDeProductionService} from "../../../../core/services/entities/unites-de-production.service";
import {GestionFournisseurService} from "../../../../core/services/gestion-fournisseurs/gestion-fournisseur.service";
import {FournisseurDTO} from "../../../../core/dtos/fournisseur-d-t-o";
import {CatalogueAchatDTO} from "../../../../core/dtos/catalogue-achat-dto";
import {CataloguesAchatsService} from "../../../../core/services/entities/catalogues-achats.service";
import {GroupeAchatCaViewModel} from "../../../../core/models/gestion-produits/catalogue-achat/groupe-achat-ca-view.model";
import {UniteDeProduction__zoneDeStockageService} from "../../../../core/services/entities/unite-de-production__zone-de-stockage.service";
import {ZoneDeStockageDTO} from "../../../../core/dtos/zone-de-stockage-dto";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {ProduitDeclinaisonDTO} from "../../../../core/dtos/produit-declinaison-dto";
import * as moment from "moment";
import {GenericDatagridService} from "../../../../core/services/generics/generic-datagrid.service";
import {UniteDeMesureDTO} from "../../../../core/dtos/unitedemesure-dto";
import {GenericFormService} from "../../../../core/services/generics/generic-form.service";
import {StockDTO} from "../../../../core/dtos/stock-dto";
import {StocksService} from "../../../../core/services/gestion-stock/stocks.service";
import {ToastService} from "../../../../core/services/technique/toast.service";
import {ImageBase64DTO} from "../../../../core/dtos/images/ImageBase64DTO";
import {ButtonThemeEnum} from "../../../../shared/ui/button/button-theme-enum";

@Component({
    selector: 'yo-dialog-lot-ajout',
    templateUrl: './dialog-lot-ajout.component.html',
    styleUrls: ['./dialog-lot-ajout.component.scss'],
    standalone: false
})
export class DialogLotAjoutComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;

  localeFr = DATEPICKER_FR;

  displayDialog: boolean = false;
  loadingVisible: boolean = false;
  isDisplayStockPanel: boolean = false;

  form: FormGroup;

  fournisseurList: FournisseurDTO[] = [];
  fournisseurSelected: FournisseurDTO;
  fournisseurWithArticlePrefereSelected: FournisseurDTO;
  uniteProductionList: UniteDeProductionDTO[] = [];
  uniteProductionSelected: UniteDeProductionDTO;
  catalogueAchatList: CatalogueAchatDTO[] = [];
  selectedGacaViewModel: GroupeAchatCaViewModel;
  catalogueAchatSelectedForGacaViewModel: CatalogueAchatDTO;

  updateSelectedGacaViewModel = (value: GroupeAchatCaViewModel) => {
    this.selectedGacaViewModel = value;
    if (value?.prixUF?.value != null && this.form) {
      this.form.controls['prixUnitaire'].setValue(value.prixUF.value);
    }
  };

  zoneStockageList: ZoneDeStockageDTO[] = [];
  zoneStockageSelected: ZoneDeStockageDTO;

  selectedMatierePremiere: ModelViewInventaire;
  selectedInventaire: ModelViewInventaire;

  idProduitDeclinaison: number;
  produitDeclinaison: ProduitDeclinaisonDTO;

  subOpenDialogAjoutLot: Subscription;

  uniteDeFacturation: UniteDeMesureDTO;
  uniteDeStockage: UniteDeMesureDTO;

  stock: StockDTO = new StockDTO();

  dateEntreeChange: boolean = false;

  isImagePopupOpened: boolean = false;

  constructor(public utils: UtilsService,
              private gfs: GenericFormService,
              private cd: ChangeDetectorRef,
              private produitDeclinaisonSvc: ProduitDeclinaisonService,
              private udpSvc: UnitesDeProductionService,
              private gestionFournisseurSvc: GestionFournisseurService,
              private udpZdsSvc: UniteDeProduction__zoneDeStockageService,
              private catalogueAchatSvc: CataloguesAchatsService,
              private gds: GenericDatagridService,
              private stockSvc: StocksService,
              private toastSvc: ToastService) {
  }

  ngOnInit() {
    this.initData();
  }

  ngOnDestroy(): void {
    this.fournisseurList = [];
    this.uniteProductionList = [];
    this.uniteProductionSelected = null;
    this.fournisseurSelected = null;
    this.utils.unsubscribe(this.subOpenDialogAjoutLot);
  }

  initData = () => {
    this.initUdpList();
    this.initForm();
    this.subscriptionOpenDialog();
  }

  closeDialog = () => {
    this.clearData();
    this.isDisplayStockPanel = false;
    this.displayDialog = false;
  };

  clearData = () => {
    this.catalogueAchatList = [];
    this.selectedGacaViewModel = null;
  };

  subscriptionOpenDialog = () => {
    this.subOpenDialogAjoutLot = this.produitDeclinaisonSvc.openDialogAjoutLot$.pipe(
      switchMap((response: DialogStockAjoutLotSupplier) => {

        this.loadingVisible = true;
        this.displayDialog = false;
        this.selectedMatierePremiere = response.selectedMatierePremiere;
        this.selectedInventaire = response.selectedInventaire;

        this.idProduitDeclinaison = this.selectedMatierePremiere ? this.selectedMatierePremiere.id : this.selectedInventaire.id;

        return this.loadLotData(this.uniteProductionSelected.id).pipe(
          catchError(err => {
            this.utils.handleError(err, true);
            return EMPTY;
          }),
          finalize(() => this.loadingVisible = false)
        );
      }))
      .subscribe(() => this.displayDialog = true);
  };

  private loadLotData = (idUdp: number): Observable<ResponseWrapper<CatalogueAchatDTO> | null> =>
    forkJoin({
    produitDeclinaisonResponse: this.gds.getOne(this.produitDeclinaisonSvc.getEntityName(), this.idProduitDeclinaison),
    zoneStockageResponse: this.udpSvc.getZoneDeStockageByIdUdp(idUdp),
    fournisseurResponse: this.gestionFournisseurSvc.getFournisseurListByIdUdpAndIdProduitDeclinaison(idUdp, this.idProduitDeclinaison)
  }).pipe(
    switchMap(({produitDeclinaisonResponse, zoneStockageResponse, fournisseurResponse}) => {
      this.produitDeclinaison = produitDeclinaisonResponse.one;
      this.zoneStockageList = zoneStockageResponse.resultList;
      this.fournisseurList = fournisseurResponse.resultList;
      this.isDisplayStockPanel = false;
      this.uniteDeStockage = null;
      this.uniteDeFacturation = null;
      this.initForm();
      this.updateZoneStockageSelected();

      if (!this.zoneStockageList.length) {
        this.zoneStockageList = null;
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.WARNING,
          `L'unité de production ${this.uniteProductionSelected?.libelle}
          ne possède pas de zone de stockage`);
      }

      if (!this.fournisseurList.length) {
        this.clearData();
        this.fournisseurSelected = null;
        this.fournisseurWithArticlePrefereSelected = null;
        this.catalogueAchatSelectedForGacaViewModel = null;

        this.toastSvc.displayToast(
          MSG_KEY.ROOT,
          MSG_SEVERITY.WARNING, `
          L'unité de production ${this.uniteProductionSelected?.libelle}
          ne possède pas de fournisseur(s) pour la Denrée :
          ${this.selectedMatierePremiere ? this.selectedMatierePremiere.produitDeclinaisonLibelle :
            this.selectedInventaire.produitDeclinaisonLibelle}`);
        return of(null);
      }

      return this.catalogueAchatSvc.findArticlePrefere(this.idProduitDeclinaison, idUdp).pipe(
        switchMap(response => {
          const catalogueAchatPrefere = response.one?.groupeAchatCa?.catalogueAchat;
          const idFournisseurPrefere = catalogueAchatPrefere?.fournisseur?.id;
          this.fournisseurSelected = this.fournisseurList.find(f => f.id === idFournisseurPrefere) ?? this.fournisseurList[0];
          this.fournisseurWithArticlePrefereSelected = this.fournisseurList.find(f => f.id === idFournisseurPrefere);
          this.updateSelectedGacaViewModel(response.one?.groupeAchatCa ?? null);
          this.catalogueAchatSelectedForGacaViewModel = catalogueAchatPrefere ?? null;

          return this.catalogueAchatSvc.getCatalogueAchatByIdAndIdPdAndIdFournisseur(
            idUdp, this.idProduitDeclinaison, this.fournisseurSelected.id, this.form.controls['dateEntree'].value);
        })
      );
    }),
    tap(response => {
      if (response) {
        this.applyCatalogueAchatList(response.resultList);
      }
    })
  );

  private updateZoneStockageSelected = () => {
    if (this.zoneStockageList && this.zoneStockageList.length > 0 && this.produitDeclinaison?.zoneDeStockage)
      this.zoneStockageSelected = this.zoneStockageList.find(zds => zds.id == this.produitDeclinaison.zoneDeStockage.id);
  }

  initUdpList = () => {
    this.udpSvc.getUniteDeProductionlist(TYPE_LIST_UDP.OnlyLocal).subscribe((response: ResponseWrapper<UniteDeProductionDTO>) => {
      this.uniteProductionList = response.resultList;
      if (response.resultList.length > 0) {
        this.uniteProductionSelected = response.resultList[0];
      }
    });
  };

  onChangeUdp = event => {
    // bloquer undefined ou null ou la réémission de l'unité de production déjà sélectionnée
    if (!event || event === this.uniteProductionSelected?.id) {
      return;
    }
    this.uniteProductionSelected = this.uniteProductionList.find(u => u.id === event);
    this.loadingVisible = true;
    this.loadLotData(this.uniteProductionSelected.id).pipe(
      catchError(err => {
        this.utils.handleError(err, true);
        return EMPTY;
      }),
      finalize(() => this.loadingVisible = false)
    ).subscribe();
  };

  onChangeFournisseur = event => {
    // bloquer undefined ou null ou la réémission du fournisseur déjà sélectionné
    if (!event || event === this.fournisseurSelected?.id) {
      return;
    }
    this.updateSelectedGacaViewModel(null);
    this.catalogueAchatSelectedForGacaViewModel = null;
    if (event == this.fournisseurWithArticlePrefereSelected?.id) this.findArticlePrefere();
    else {
      this.fournisseurSelected = this.fournisseurList.find(f => f.id === event);
      this.loadCatalogueAchat();
    }
  };

  loadCatalogueAchat = () => {
    if (!this.utils.isNullOrEmpty(this.uniteProductionSelected) && !this.utils.isNullOrEmpty(this.idProduitDeclinaison) && !this.utils.isNullOrEmpty(this.fournisseurSelected)) {
      this.catalogueAchatSvc.getCatalogueAchatByIdAndIdPdAndIdFournisseur(this.uniteProductionSelected.id,
        this.idProduitDeclinaison, this.fournisseurSelected.id, this.form.controls['dateEntree'].value).subscribe((response: ResponseWrapper<CatalogueAchatDTO>) => {
        this.applyCatalogueAchatList(response.resultList);
      });
    }
  };

  private applyCatalogueAchatList = (catalogueAchatList: CatalogueAchatDTO[]): void => {
    this.catalogueAchatList = catalogueAchatList;
    const catalogueAchat = this.catalogueAchatList.find(
      ca => ca.id === this.catalogueAchatSelectedForGacaViewModel?.id)
      ?? this.catalogueAchatList[0];
    const gaca = catalogueAchat?.groupeAchatCaList.find(
      g => g.id === this.selectedGacaViewModel?.id)
      ?? catalogueAchat?.groupeAchatCaList[0];
    this.updateGacaViewModel(gaca, catalogueAchat);
  };

  updateGacaViewModel = (gaca: GroupeAchatCaViewModel, catalogueAchat: CatalogueAchatDTO) => {
    if (gaca) {
      this.catalogueAchatSelectedForGacaViewModel = catalogueAchat;
      this.updateSelectedGacaViewModel(gaca);
      if (!this.dateEntreeChange) {
        this.form.controls['dateEntree'].setValue(new Date());
        this.form.controls['dlc'].setValue(this.getDlcDate(new Date(), this.produitDeclinaison));
      }
      this.form.controls['lotFabriquant'].setValue('');
      this.form.controls['quantite'].setValue(0);

      this.uniteDeStockage = catalogueAchat.uniteDeStockage;
      this.uniteDeFacturation = catalogueAchat.uniteDeFacturation;

      this.isDisplayStockPanel = true;
      this.cd.markForCheck();
    }
  };

  findArticlePrefere = () => {
    this.catalogueAchatSvc.findArticlePrefere(this.idProduitDeclinaison, this.uniteProductionSelected.id)
      .subscribe(res => {
        if (res.one && res.one.groupeAchatCa && res.one.groupeAchatCa.catalogueAchat && res.one.groupeAchatCa.catalogueAchat.fournisseur && res.one.groupeAchatCa.catalogueAchat.fournisseur.id) {
          this.fournisseurSelected = this.fournisseurList.find(f => f.id === res.one.groupeAchatCa.catalogueAchat.fournisseur.id);
          this.fournisseurWithArticlePrefereSelected = this.fournisseurList.find(f => f.id === res.one.groupeAchatCa.catalogueAchat.fournisseur.id);
          this.updateSelectedGacaViewModel(res.one.groupeAchatCa);
          this.catalogueAchatSelectedForGacaViewModel = res.one.groupeAchatCa.catalogueAchat;
        } else this.fournisseurSelected = this.fournisseurList[0];

        this.loadCatalogueAchat();
      });
  }

  initForm = () => {
    this.stock = new StockDTO();
    let dlc = this.produitDeclinaison ? this.getDlcDate(new Date(), this.produitDeclinaison) : new Date();
    this.form = new FormGroup({
      quantite: new FormControl(0, [Validators.required, Validators.min(0.0001)]),
      prixUnitaire: new FormControl(0, [Validators.required]),
      lotFabriquant: new FormControl(''),
      dlc: new FormControl(dlc, Validators.required),
      dateEntree: new FormControl(new Date(), Validators.required),
      zoneDeStockageId: new FormControl(1, Validators.required)
    });
  };

  getDlcDate = (date: Date, produitDeclinaison: ProduitDeclinaisonDTO) => {
    const momentDlc = moment(date);
    let dateDlc = new Date();

    if (produitDeclinaison && produitDeclinaison.dlc > 0) {
      dateDlc = momentDlc.add(produitDeclinaison.dlc, 'days').toDate();
    }
    return dateDlc;
  };


  ajouterLot = () => {
    this.gfs.validateAllFormFields(this.form);
    if (this.form.valid && !this.utils.isNullOrEmpty(this.zoneStockageSelected) && !this.utils.isNullOrEmpty(this.selectedGacaViewModel)) {
      this.stock.idUdp = this.uniteProductionSelected.id;
      this.stock.produitDeclinaisonCode = this.produitDeclinaison.code;
      this.stock.quantite = this.form.controls['quantite'].value;
      this.stock.prixUnitaire = this.form.controls['prixUnitaire'].value;
      this.stock.lotArticleFournisseur = this.form.controls['lotFabriquant'].value;
      this.stock.idZoneDeStockage = this.zoneStockageSelected.id;
      this.stock.zdsLibelle = this.zoneStockageSelected.libelle;
      this.stock.idCatalogueAchat = this.selectedGacaViewModel.idCatalogueAchat;
      this.stock.dlc = this.form.controls['dlc'].value;
      this.stock.dateEntree = this.form.controls['dateEntree'].value;
      this.stock.dluo = this.form.controls['dateEntree'].value;
      this.stockSvc.saveStock(this.stock).subscribe(response => {
        if (!this.utils.isNullOrEmpty(response)) {
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Le lot a été enregistré avec succès`);
          // actualiser les lignes de stock
          this.stockSvc.announceLoadStocks(this.selectedMatierePremiere);
          this.produitDeclinaisonSvc.announcePaginationSearchStock({page: 0, size: 50});
          this.closeDialog();
        }
      });
    } else {
      if (this.form.controls['quantite'].invalid)
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, `Veuillez renseigner la quantité`);
      if (this.utils.isNullOrEmpty(this.zoneStockageSelected))
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, `Veuillez renseigner la zone de stockage`);
      if (this.utils.isNullOrEmpty(this.selectedGacaViewModel))
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, `Veuillez sélectionner un article`);
    }
  };

  isDisabledSaveBtn = () => !this.form.valid;

  onChangeZoneStockage = (event: number) => {
    // bloquer undefined ou null ou la réémission de la zone de stockage déjà sélectionnée
    if (!event || event === this.zoneStockageSelected?.id) {
      return;
    }
    this.zoneStockageSelected = this.zoneStockageList.find(zds => zds.id == event);
  };

  refreshArticleWhenDateEntreeChanged = () => {
    this.dateEntreeChange = true;
    this.form.controls['dlc'].setValue(this.getDlcDate(this.form.controls['dateEntree'].value, this.produitDeclinaison));
    this.loadCatalogueAchat();
  }

  openImageDialog() {
    this.isImagePopupOpened = true;
  }

  getImageCount() {
    if (this.stock.images?.length > 0)
      return "x " + this.stock.images.length;
    return null;
  }

  onImagePopupClose = (images: ImageBase64DTO[]) => {
    this.isImagePopupOpened = false;
    this.stock.images = images;
  };
}
